import { atom } from 'jotai'

export type FrontmanState = {
  isInitialized: boolean
  hasError: boolean
}

export const frontmanState = atom<FrontmanState>({
  isInitialized: false,
  hasError: false,
})
